import { Text as MantineText } from '@mantine/core';
import { isSameDate } from '@mantine/dates';

type Props = {
  date: Date;
  selected: boolean;
};

const CalendarDay = ({ date, selected }: Props) => {
  const today = isSameDate(date, new Date());
  let color = 'inherit';

  if (today) color = 'blue';
  if (selected) color = 'white';

  return (
    <MantineText weight={selected || today ? 'bolder' : 'normal'} color={color}>
      {date.getDate()}
    </MantineText>
  );
};

export default CalendarDay;
